import * as types from './type';

import { Spotify }  from  '../../services/spotify';

export function getSpotifyPlaylists(params) {
  return {
    type: types.GET_SPOTIFY_PLAYLISTS,
    payload: Spotify.getSpotifyPlaylists(params),
  };
}

export function loadMoreSpotifyPlaylists(params) {
  return {
    type: types.LOAD_MORE_SPOTIFY_PLAYLISTS,
    payload: Spotify.getSpotifyPlaylists(params),
  };
}